export default __webpack_public_path__ + "images/e5919586bf7ad88b14ceaabfc783bc4b-snake-game.svg";